class PollingManager {
  constructor() {
    this.tasks = {}
    this.timers = {}
  }

  register(task) {
    if (!task || !task.key || !task.interval || typeof task.handler !== 'function') {
      throw new Error('[polling] invalid task')
    }

    this.tasks[task.key] = task
    return task
  }

  run(key) {
    const task = this.tasks[key]
    if (!task) return Promise.resolve(false)

    return Promise.resolve()
      .then(() => task.handler())
      .catch(error => {
        console.error(`[polling:${key}] failed`, error)
        return false
      })
  }

  start(key) {
    const task = this.tasks[key]
    if (!task) return null
    if (this.timers[key]) return this.timers[key]

    this.timers[key] = setInterval(() => {
      this.run(key)
    }, task.interval)

    return this.timers[key]
  }

  startAll() {
    Object.keys(this.tasks).forEach(key => {
      this.start(key)
    })
  }

  stop(key) {
    if (!this.timers[key]) return

    clearInterval(this.timers[key])
    delete this.timers[key]
  }

  stopAll() {
    Object.keys(this.timers).forEach(key => {
      this.stop(key)
    })
  }
}

export default PollingManager
